import { render, staticRenderFns } from "./AntecipacaoCarteira.vue?vue&type=template&id=f2a32fea&scoped=true"
import script from "./AntecipacaoCarteira.vue?vue&type=script&lang=ts"
export * from "./AntecipacaoCarteira.vue?vue&type=script&lang=ts"
import style0 from "./AntecipacaoCarteira.vue?vue&type=style&index=0&id=f2a32fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a32fea",
  null
  
)

export default component.exports